<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
#app {
  font-family: 'THSarabunNew','Circular',sans-serif;
  font-weight: bolder;
}

</style>
<script>
  import FooterView from "./views/FooterView";
  export default {
    components: {FooterView},
    created () {
    }
  }
</script>
